// DEPENDENCIES
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
// COMPONENTS
import { Link } from 'react-router-dom';
import MUIDataTable from "mui-datatables";
import SVG from "react-inlinesvg";
import { Spinner, OverlayTrigger, Tooltip } from "react-bootstrap";
import { NavLink } from "react-router-dom";
// CUSTOM COMPONENTS
// SERVICES AND HELPERS
import { getAllUsers } from "../../../services/management/userService";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import constants from '../../../constants/constants';

const UserListingPage = (props) => {
    const { auth } = props;
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showActive, setShowActive] = useState(true);

    useEffect(() => {
        getAllUsers(!auth.isAdmin, showActive).then(res => {
            setData(res);
        }).catch(ex => { })
            .finally(() => setLoading(false));
    }, [showActive])

    const columns = [
        {
            name: "id",
            label: "Actions",
            options: {
                filter: false,
                sort: false,
                width: 1,
                print: false,
                download: false,
                customBodyRenderLite: (dataIndex) => {
                    return (
                        <NavLink
                            to={"/management/user-profile/" + data[dataIndex].id}
                            href="#"
                            className="btn btn-sm btn-info font-weight-bold py-2 px-3 px-xxl-5"
                        >
                            {auth.isAdmin ? "Edit" : "View"}
                        </NavLink>
                    );
                }
            },
        },
        {
            name: "fullName",
            label: "Name",
            options: {
                filterType: 'multiselect',
                sort: true,
                customBodyRenderLite: (dataIndex) => {
                    return (
                        <div className="tc-user-block">
                            <div
                                className="img-block background-image-container"
                                style={{ backgroundImage: `url(${data[dataIndex].imageUrl ? (constants.API_URL + data[dataIndex].imageUrl) : ("/media/users/default.jpg")})` }}
                            >
                            </div>

                            <div className="user-info-block">
                                <Link to={"/management/user-profile/" + data[dataIndex].id} className="text-dark font-weight-bolder text-hover-primary mb-1 font-size-lg">
                                    {data[dataIndex].fullName}
                                </Link>
                                <span className="text-muted font-weight-bold d-block">
                                    {data[dataIndex].role}
                                </span>
                            </div>
                        </div>
                    );
                }
            }
        },
        {
            name: "userName",
            label: "Username",
            options: {
                filterType: 'multiselect',
                sort: true,
            }
        },
        {
            name: "isActive",
            label: "Is Active?",
            options: {
                filter: true,
                sort: true,
                customBodyRenderLite: (dataIndex) => {
                    return (
                        <>
                            <SVG
                                className="h-50 align-self-center"
                                src={toAbsoluteUrl(data[dataIndex].isActive === "True" ? "/media/svg/icons/Navigation/Check.svg" : "/media/svg/icons/Navigation/Close.svg")}
                            >
                            </SVG>
                        </>
                    );
                }
            }
        },
    ];

    return (
        <div className="row">
            <div className="col-lg-12 col-xxl-12">
                <div className={`card card-custom card-stretch gutter-b}`}>
                    <div className="card-header border-0 py-5">
                        <h3 className="card-title align-items-start flex-column">
                            <span className="card-label font-weight-bolder text-dark archive-unarchive-span">
                                Users
                                <OverlayTrigger
                                    key={'right'}
                                    placement={'right'}
                                    overlay={
                                        <Tooltip id={`tooltip-right`}>
                                            Switch to <strong> {showActive ? "In Active" : "Active"}</strong>
                                        </Tooltip>
                                    }
                                >
                                    <span
                                        onClick={() => setShowActive(!showActive)} style={{ cursor: 'pointer' }}
                                        className={`label label-xl label-inline label-light-${showActive ? "success" : "warning"}`}
                                    >
                                        {showActive ? "Active" : "In Active"}
                                    </span>
                                </OverlayTrigger>
                            </span>
                            <span className="text-muted mt-3 font-weight-bold fz-xs">
                                View { auth.isAdmin && 'and Manage'} Users
                            </span>
                        </h3>
                        <div className="card-toolbar">
                            {
                                auth.isAdmin ?
                                    <NavLink
                                        to={"/management/add-user"}
                                        className="btn btn-success font-weight-bolder font-size-sm mr-3"
                                    >
                                        <span className="svg-icon svg-icon-lg svg-icon-white">
                                            <SVG
                                                src={toAbsoluteUrl(
                                                    "/media/svg/icons/Code/Plus.svg"
                                                )}
                                            />
                                        </span> Add User
                                    </NavLink> : <></>
                            }

                        </div>
                    </div>
                    <div className="container-fluid">
                        <MUIDataTable
                            data={data}
                            columns={columns}
                            options={{
                                rowsPerPage: 25,
                                rowsPerPageOptions: [10, 15, 20, 25, 30, 35, 40, 45, 50, 100],
                                selectableRows: 'none',
                                downloadOptions: {
                                    filename: 'Users.csv',
                                    filterOptions: {
                                        useDisplayedColumnsOnly: true,
                                        useDisplayedRowsOnly: true
                                    }
                                },
                                textLabels: {
                                    body: {
                                        noMatch: loading ?
                                            <Spinner animation="border" size="lg" variant="info" /> :
                                            'Sorry, no matching records found.',
                                    },
                                }
                            }}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => ({
    auth: state.auth
})

export default connect(mapStateToProps, null)(UserListingPage);